import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import Error from '../components/Error';
import Loader from '../components/Loader';
import Overview from './Overview';
import { LanguageContext } from '../lib/LanguageContext'
import * as helpers from '../lib/helpers';
import * as apiCalls from '../lib/apiCalls';
import '../App.css';
import './OverviewWrapper.css'


const NOAUTH = 403;
const SERERROR = 500;

class OverviewWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      institution: {
        // institutionName: '',
        departments: [],
      },
      institutionRouteName: '',
      loading: 'initial',
      redirectError: false,
      redirectServerError: false
    };
  }


  loadInstitutionDepartments = async () => {
    const res = await apiCalls.getInstitutionDepartments(this.props.institutionId, this.props.runType); //Change this
    return res;
  }

  async componentDidMount() {
    document.title = this.context.polyglot.t('overviewPageTitle');
    const res = await this.loadInstitutionDepartments();
    if(res === NOAUTH) {
      return this.setState(prevState => ({
        ...prevState,
        redirectError: true,
        loading: 'false'
      }))
    } else if(res === SERERROR || 'error' in res) {
      return this.setState(prevState => ({
        ...prevState,
        redirectServerError: true,
        loading: 'false'
      }))
    }
    else {
      this.setState({ loading: 'true' });
      this.setState(prevState => ({
        institution: {
          ...prevState.institution,
          // institutionName: res.institutionName,
          departments: res.departmentIds.filter((obj, pos, arr) => {
            return arr.map(mapObj => mapObj['id']).indexOf(obj['id']) === pos;
          }).map(dep => { return {...dep, nameEl: helpers.removeSpecialChars(dep.nameEl)}}),
          institutionRouteName: this.props.institutionId.toLowerCase(),
        },
        loading: 'false',
      }));
    }
  }

  render() {
    if (this.state.loading === 'true' || this.state.loading === 'initial') {
      return   (
            <Loader />
      )     
    }


    if (this.state.redirectError === true) {
      return <Redirect push to={`/login?next=${this.props.location}`}/>      
    }

    if (this.state.redirectServerError === true) {
      return (
        <Error />
      )
    }

    return (
      <div className='OverviewWrapper'>
        <Route
          path="/overview/:depId"
          render={(props) => {
            if (
              props.match.params.depId !== 'all'
              && this.state.institution.departments.filter(
                dep => dep.id === props.match.params.depId,
              ).length === 0
            ) {
              return <Redirect to="all" />;
            }
            return <Overview institution={this.state.institution} handleModal={this.props.handleModal} 
                             id={props.match.params.depId} showHideNav={this.props.showHideNav} 
                             institutionId={this.props.institutionId} runType={this.props.runType}
                             handleLogout={this.props.handleLogout} 
                             handleError={this.props.handleError} token={this.props.token} 
                             location={props.location.pathname}/>;
          }}
        />
        <Route exact path="/overview" render={() => <Redirect push to="/overview/all" />} />
      </div>
    );
  }
}
OverviewWrapper.contextType = LanguageContext

export default OverviewWrapper;



// WEBPACK FOOTER //
// ./src/overview/OverviewWrapper.js